"use client";

import { c as _c } from "react/compiler-runtime";
import type { FC, PropsWithChildren } from "react";
import type { DataTarget } from "~/shared/styles";
export type WarningTextProps = DataTarget;
import styles from "./WarningTest.module.scss";
export const WarningText: FC<PropsWithChildren<WarningTextProps>> = t0 => {
  const $ = _c(6);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props) {
    t1 = <small className={styles.warning} {...props}>{children}</small>;
    $[3] = children;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default WarningText;